import { BookingInfo } from "../../customHook/BookingInfo";
import { TraditionalDeposit } from "../../customHook/TraditionalDeposit";
import { useDepositLogic } from "../../customHook/useDepositLogic";
import { EasyDepositFormik } from "./EasyDepositFormik";


export function DepositInstallmentsFormik() {
  const {
    paymentMethod,
    deposit,
    easyDeposit,
    valueCaucao,
    valueDeposit,
    typePayment,
    setPaymentMethod,
    setEasyDeposit,
    handleDepositChange,
  } = useDepositLogic();

  const shouldShowTraditionalDeposit = !easyDeposit && (
    (valueCaucao !== 0 && valueDeposit !== 0) ||
    (valueCaucao === 0 && valueDeposit === 0)
  );

  return (
    <section className="space-y-6">
      {/* Componente Segregado para Caução Facilitado */}
      <EasyDepositFormik
        easyDeposit={easyDeposit}
        setEasyDeposit={setEasyDeposit}
      />

      {/* Informações da Reserva */}
      <BookingInfo
        valueDeposit={valueDeposit}
        typePayment={typePayment}
        valueCaucao={valueCaucao}
      />

      {/* Caução Tradicional */}
      {shouldShowTraditionalDeposit && (
        <TraditionalDeposit
          paymentMethod={paymentMethod}
          deposit={deposit}
          onPaymentMethodChange={setPaymentMethod}
          onDepositChange={handleDepositChange}
        />
      )}
    </section>
  );
}